
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { ConsultarFuncionarioBicicletaRouting } from './consultar-funcionario-bicicleta-routing.module';
import { ConsultarFuncionarioBicicletaComponent } from './consultar-funcionario-bicicleta.component';

  
  @NgModule({
    declarations: [ConsultarFuncionarioBicicletaComponent],
    imports: [
      SharedModule,
      CommonModule,
      ConsultarFuncionarioBicicletaRouting
    ],
    entryComponents: []
  })

  export class ConsultarFuncionarioBicicletaModule{}